module.exports = __webpack_public_path__ + "img/map-pin-off.56e8807c.svg";